export const FLAG_GETTING_BILLINGS = 'FLAG_GETTING_BILLINGS';
export const GET_BILLINGS = 'GET_BILLINGS';
export const CLEAR_BILLINGS = 'CLEAR_BILLINGS';
export const FLAG_BILLING_ACTIVITY = 'FLAG_BILLING_ACTIVITY';
export const GET_BILLING = 'GET_BILLING';
export const CLEAR_BILLING = 'CLEAR_BILLING';
export const CLEAR_BILLING_REPORT = 'CLEAR_BILLING_REPORT';
export const GET_BILLING_REPORT = 'GET_BILLING_REPORT';
export const FLAG_GETTING_BILLING_REPORT = 'FLAG_GETTING_BILLING_REPORT';
export const FLAG_GETTING_BILLING_REPORT_DETAILS =
  'FLAG_GETTING_BILLING_REPORT_DETAILS';
export const GET_BILLING_REPORT_DETAILS = 'GET_BILLING_REPORT_DETAILS';
export const CLEAR_BILLING_REPORT_DETAILS = 'CLEAR_BILLING_REPORT_DETAILS';
export const FLAG_BILLING_REPORT_DETAIL_ACTIVITY =
  'FLAG_BILLING_REPORT_DETAIL_ACTIVITY';
export const GET_BILLING_REPORT_DETAIL = 'GET_BILLING_REPORT_DETAIL';
export const CLEAR_BILLING_REPORT_DETAIL = 'CLEAR_BILLING_REPORT_DETAIL';
export const GET_BILLINGS_RETENTION = 'GET_BILLINGS_RETENTION';
export const CLEAR_BILLINGS_RETENTION = 'CLEAR_BILLINGS_RETENTION';
export const FLAG_GETTING_BILLINGS_RETENTION =
  'FLAG_GETTING_BILLINGS_RETENTION';
